import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(callback-with-footer)/legals/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/GlobalStyles.tsx");
